<div class="acctypescont text-center" *ngIf="this.visible==true">
    <div class="tabCentered">
        <div class="tabCentered2">
            <div (click)="this.changeTab('postpago',1)" class="acctype on" [ngClass]="{'on': postpago}">
                <div class="autocont full vcenter">
                    <div class="tabcell tabMovil1">
                        <img width="100%" src="../../assets/images/postpaid-icon.png"> Postpago
                    </div>
                </div>
            </div>
            <div (click)="this.changeTab('prepago',1)" class="acctype" [ngClass]="{'on': prepago}">
                <div class="autocont full vcenter">
                    <div class="tabcell tabMovil1">
                        <img width="100%" src="../../assets/images/prepaid-icon.png"> Prepago
                    </div>
                </div>
            </div>
            <div (click)="this.changeTab('telefoniaFijo',1)" class="acctype" [ngClass]="{'on': telefoniaFijo}">
                <div class="autocont full vcenter">
                    <div class="tabcell tabMovil1">
                        <img width="100%" src="../../assets/images/fixedphone-icon.png"> Servicios Fijos
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>